import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ContentPage.css';

/**
 * 404 页面：服务器对未知路径返回 404 状态码（回退到 index.html），
 * 前端渲染此专用页面，提供错误提示与返回首页入口。
 */
const NotFoundPage: React.FC = () => {
    useEffect(() => {
        document.title = '页面未找到｜妙视力';
        let meta = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
        if (!meta) {
            meta = document.createElement('meta');
            meta.setAttribute('name', 'robots');
            document.head.appendChild(meta);
        }
        meta.setAttribute('content', 'noindex');
    }, []);

    return (
        <div className="content-page not-found-page">
            <div className="content-page-inner">
                <h1>404</h1>
                <p className="not-found-message">抱歉，您访问的页面不存在。</p>
                <div className="content-links not-found-links">
                    <Link to="/">返回首页</Link>
                    <Link to="/product/">产品与资质</Link>
                    <Link to="/download/">下载软件</Link>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;
